export default __webpack_public_path__ + "locales/fr/Common.json?hash=6f50652db199eeec53d95b2276372e10";